





















































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {ContactParams} from "../../../params";
import EnumSelector from "../../../../../shared/components/EnumSelector/index.vue";
import PostOfficeSelector from "../../../../../shared/components/PostOfficeSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {ContactStore} from "@/modules/contact/store";
import debounce from "lodash/debounce";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
@Component({
    name: "ContactSearch",
    components: {PartnerSelector, DistrictSelector, ProvinceSelector, PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    params = new ContactParams();
    CommonStatus = CommonStatus;

    @Watch("params", { deep: true })
    onchangeParams(val: any) {
        this.handleChangeParams(val);
    }

    handleChangeParams = debounce((val: any) => {
        const params = {...val, page: 1};
      ContactStore.updateParams(params);
      ContactStore.listContacts(params);
    }, 500)
}
